import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconBowling: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBowling"><Path d="M14.8984 8.25C14.8984 9.07843 14.2269 9.75 13.3984 9.75C12.57 9.75 11.8984 9.07843 11.8984 8.25C11.8984 7.42157 12.57 6.75 13.3984 6.75C14.2269 6.75 14.8984 7.42157 14.8984 8.25Z" fill="currentColor"/><Circle cx="16.5" cy="11.5" r="1.5" fill="currentColor"/><Circle cx="12.25" cy="12.5" r="1.5" fill="currentColor"/><Circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconBowling;
